<template>
  <div class="liu pos-manage">
    <div class="scroll-container current-padding-top" :style="customScrollHeight">
      <!-- 上部tab菜单 -->
      <div class="tab-menu">
        <div class="tab-menu-item current-tab">
          <span>请选择注册方式</span>
        </div>
      </div>
      <div class="big-item" @click="onItem1Click">
        <div class="big-item-col img-col">
          <img class="img" src="../../assets/customer_first_menu_1.png" alt="">
          <span class="title">企业</span>
        </div>
        <div class="big-item-col txt-col">
          <span>○ 身份证</span>
          <span>○ 营业执照</span>
          <span>○ 开户许可证(银行卡)</span>
        </div>
      </div>
      <div class="big-item" style="background-color:#3782dc!important;margin-top:0.75rem" @click="onItem2Click">
        <div class="big-item-col img-col">
          <img class="img" src="../../assets/customer_first_menu_2.png" alt="">
          <span class="title">个人</span>
        </div>
        <div class="big-item-col txt-col">
          <span>○ 手机号</span>
          <span>○ 邀请码</span>
          <span>&nbsp;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseRegisterIndex',
  data() {
    return {};
  },
  mounted() {},
  computed: {
    customScrollHeight() {
      return `padding-top:3rem;height:${window.innerHeight}px;`;
    },
  },
  methods: {
    onItem1Click() {
      this.$router.push({ path: '/enterpriseregister', query: { welcomecode: this.$route.query.welcomecode, name: this.$route.query.name } });
    },
    onItem2Click() {
      this.$router.push({ path: '/register', query: { welcomecode: this.$route.query.welcomecode, name: this.$route.query.name } });
    },
  },
};
</script>

<style lang="scss" scoped>
.current-tab {
  width: 100% !important;
  margin-left: 1.1rem !important;
  margin-right: 1.1rem !important;

  span {
    color: #000 !important;
  }
}
.tab-menu {
  top: 0;
}
</style>
